import React, { useEffect, useState } from "react";
import { Badge } from "../components/common";
import { getUsers } from "../api/dashboardService.js";

export default function UsersPage() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const data = await getUsers();
      setUsers(data);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="p-4 sm:p-7">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-3 mb-5">
        <div>
          <h1
            className="text-2xl font-normal mb-1"
            style={{ fontFamily: "serif" }}
          >
            वापरकर्ता व्यवस्थापन
          </h1>
          <p className="text-sm text-slate-500">भूमिका व अधिकार नियंत्रण</p>
        </div>
        {/* <button className="w-full sm:w-auto bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold text-xs px-4 py-2.5 rounded-lg">
          + नवीन वापरकर्ता
        </button> */}
      </div>
      <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
        <table className="w-full text-xs border-collapse min-w-[560px]">
          <thead>
            <tr style={{ background: "#0e2a47" }} className="text-slate-100">
              {["वापरकर्ता आयडी", "भूमिका", "स्थिती"].map((h) => (
                <th key={h} className="text-left px-3 py-2.5 font-semibold">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-slate-100">
                <td className="px-3 py-2.5">{u.username}</td>

                <td className="px-3 py-2.5">
                  {u.role === "SuperAdmin"
                    ? "सुपर अ‍ॅडमिन"
                    : "अ‍ॅडमिन"}
                </td>

                <td className="px-3 py-2.5">
                  <Badge status="मंजूर" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

